import React, { memo } from "react";

const Input = ({
  className,
  name,
  id,
  type,
  value,
  onChange,
  onblur,
  autoFocus = false,
  disabled = false,
  placeholder = "",
  ...props
}) => {
  return (
    <>
      <input
        className={className}
        name={name}
        id={id}
        type={type}
        value={value}
        onChange={onChange}
        onBlur={onblur}
        autoFocus={autoFocus}
        disabled={disabled}
        placeholder={placeholder}
        onWheel={(e) => e.target.blur()}
        {...props}
      />
    </>
  );
};

export default memo(Input);
